import {
	Button,
	ButtonStack,
	NotificationCard,
	Section,
} from "@arp/react-ndbx";
import { Box, Fade, Typography } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import React, { useEffect, useState } from "react";
import Page from "../../../components/Page";
import ButtonNavigationGroup from "../../../components/organisms/ButtonNavigationGroup";
import ReviewApplicationDOD from "../../../components/pageLevel/reviewApplication/ReviewApplicationDOD";
import ReviewApplicationUWQuestions from "../../../components/pageLevel/reviewApplication/ReviewApplicationUWQuestions";
import ReviewApplicationYourDetails from "../../../components/pageLevel/reviewApplication/ReviewApplicationYourDetails";
import SendEmailModal from "../../../components/pageLevel/sendEmailModal/SendEmailModal";
import {
	Application,
	TRACKIFY_EVENT,
	sendEmailModalContent,
} from "../../../config/const/enums";
import { retrieveQuoteNotification } from "../../../config/disclaimers/disclaimers";
import { useGetQuote } from "../../../hooks/dataHooks/useGetQuoteData";
import usePreQualification from "../../../hooks/usePreQualification.ts";
import usePreQualificationPages from "../../../hooks/usePreQualificationPages.ts";
import useSharedData from "../../../hooks/useSharedData";
import { trackifyPageChange } from "@allianz/tracking";

function ReviewApplication() {
	const { state } = usePreQualificationPages();
	const { dataSet } = usePreQualification();
	const theme = useTheme();
	const { retrieveQuoteJourney } = useSharedData();
	const { personOne, application } = { ...dataSet };
	const { data: quoteData, isLoading: quoteIsLoading } = useGetQuote();
	const { currentPage } = { ...state };
	const [openSendEmailModal, setOpenSendEmailModal] = useState(false);
	const handleSendEmailOpen = () => {
		trackifyPageChange(TRACKIFY_EVENT.SEND_EMAIL_REVIEW_APPLICATION);
		setOpenSendEmailModal(true);
	};
	const handleSendEmailClose = (event, reason) => {
		if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
			setOpenSendEmailModal(false);
			setSendQuoteEmailSuccess(false);
		}
	};
	const [sendQuoteEmailSuccess, setSendQuoteEmailSuccess] = useState(false);
	const handleSuccessEmailModal = () => {
		setSendQuoteEmailSuccess(true);
	};

	useEffect(() => {
		sessionStorage.removeItem("editquestionid");
		trackifyPageChange(currentPage?.identifier?.toLowerCase());
	}, []);

	const isCC = application === Application?.CONTACT_CENTER;

	return (
		<Page title={currentPage.title} identifier={currentPage.identifier}>
			<Section mb={{ xs: 4, md: 8 }} mt={2}>
				<Typography variant="h2-bold">Review application</Typography>
			</Section>
			<Section md={7} mb={1}>
				<Typography variant="label-large-regular">
					Hi {personOne.firstName}, this is your application progress
				</Typography>
			</Section>
			<Section md={7} mb={4}>
				<Typography variant="label-large-bold">
					Quote reference: {quoteData?.quoteInformation?.quoteNumber}
				</Typography>
			</Section>
			{/* show the notification in case of retrieve journey via CC */}
			{retrieveQuoteJourney && (
				<Section md={7} mb={4}>
					<Fade in={true} timeout={500}>
						<Box>
							<NotificationCard
								cardType="info"
								title="Application retrieval important information"
								message={
									isCC
										? retrieveQuoteNotification().DISCLAIMER_TEXT_REVIEW_CC(
												dataSet["personOne"].emailAddress,
												dataSet["personOne"].contactNumber
											)
										: retrieveQuoteNotification().DISCLAIMER_TEXT_REVIEW_ONLINE
								}
							/>
						</Box>
					</Fade>
				</Section>
			)}
			<Section sx={{ borderBottom: "1px solid #707070" }} mb={{ xs: 4, md: 5 }}>
				<ReviewApplicationDOD personOne={personOne} application={application} />
			</Section>
			<Section
				sx={{ borderBottom: `${theme.palette.greyscale.Grey550}` }}
				mb={{ xs: 4, md: 5 }}
			>
				<ReviewApplicationYourDetails personOne={personOne} />
			</Section>
			<Section sx={{ borderBottom: `${theme.palette.greyscale.Grey550}` }}>
				<ReviewApplicationUWQuestions personOne={personOne} />
			</Section>
			<Section mt={6}>
				<ButtonStack>
					<Button
						variant="contained"
						color="secondary"
						onClick={handleSendEmailOpen}
					>
						SAVE AND EMAIL QUOTE
					</Button>
					<Button variant="contained" color="primary" type="submit">
						CONFIRM & PROCEED
					</Button>
				</ButtonStack>
				<Section mt={2}>
					<ButtonNavigationGroup showNextButton={false} />
				</Section>
			</Section>
			<SendEmailModal
				openSendEmailModal={openSendEmailModal}
				handleSendEmailClose={handleSendEmailClose}
				handleSuccessEmailModal={handleSuccessEmailModal}
				sendQuoteEmailSuccess={sendQuoteEmailSuccess}
				sendEmailImg={sendEmailModalContent.SEND_EMAIL_IMAGE}
				quoteStageNew={true}
			/>
		</Page>
	);
}

export default ReviewApplication;
